import type { UploadedFile } from 'models';
import { AttachmentMenu } from 'features/attachments';

type P = {
  className?: string;
  onChange?: (value: { files: UploadedFile[]; loading: boolean }) => void;
  value?: { files: UploadedFile[]; loading: boolean };
};

const AttachmentInput = ({ className, onChange, value }: P) => (
  <AttachmentMenu
    className={className}
    onStartUpload={() => {
      onChange?.({
        files: value ? value.files : [],
        loading: true,
      });
    }}
    onUpload={(files) => {
      onChange?.({
        files: value ? [...value.files, ...files] : files,
        loading: false,
      });
    }}
  />
);

export default AttachmentInput;
